<template>
    <div class="stars">
        <template v-for="n in 5">
            <b-icon v-if="n <= Math.floor(average)" icon="star" :size="size" />

            <b-icon v-else-if="n === Math.ceil(average) && average < n" icon="star-half" :size="size"  />

            <b-icon v-else icon="star-outline" :size="size"  />
        </template>
    </div>
</template>

<style lang="scss" scoped>
    .stars {
        font-weight: bold;
        color: #ffb513;

        .icon {
            margin-right: 0.2rem;

            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            average: {
                type: Number,
                required: true,
            },

            size: {
                type: String,
                required: false,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/profile/ratings/Stars.vue